import Vue from 'vue'
import router from '../../router'

export default {
  addFinancialClub ({ commit }, city) {
    commit('ADD_NEW_FINANCIAL_CLUB', city)
  },
  getFinancialClubs ({ commit }, id) {
    return Vue.axios.get(`/events/clubs`)
    .then(({ data }) => {
      commit('ADD_FINANCIAL_CLUBS', data)
      if (!id && data[0]) {
        commit('ADD_FINANCIAL_CLUB', data[0])
      }
    })
  },
  updateFinancialClubs ({ commit }, clubs) {
    commit('UPDATE_FINANCIAL_CLUBS', clubs)
    return Vue.axios.put(`/events/clubs`, { clubs })
  },
  loadClubSponsorPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/clubs/${id}/load-sponsor-logo`, formData)
  },
  loadClubLogoImage ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/clubs/${id}/change-club-logo`, formData)
  },
  deleteClubLogoImage ({ commit }) {
    commit('CHANGE_CLUB_LOGO', null)
  },
  deleteClub ({ commit, state }, id) {
    return Vue.axios.delete(`/events/clubs/${id}`)
    .then(() => {
      commit('DELETE_FINANCIAL_CLUB', id)
      if (state.clubs[0]) {
        router.push({ name: 'FinancialClub', params: { id: state.clubs[0].id } })
        commit('ADD_FINANCIAL_CLUB', state.clubs[0])
      }
    })
  },
  getFinancialClub ({ commit }, id) {
    return Vue.axios.get(`/events/clubs/${id}`)
    .then(({ data }) => commit('ADD_FINANCIAL_CLUB', data))
  },
  updateFinancialClub ({ commit }, club) {
    commit('UPDATE_FINANCIAL_CLUB', club)
  },
  saveFinancialClib ({ commit, dispatch }, club) {
    const newPhotos = club.photos.filter(p => typeof p === 'object')
    const newLogos = club.logos.filter(l => typeof l === 'object')
    const speakers = club.clubSpeakers.filter(s => typeof s.photo === 'object')

    let newPhoto
    let newLogo

    if (club.photo && club.photo.base64photo) {
      newPhoto = club.photo
      club.photo = ''
    }
    if (club.logo && club.logo.base64photo) {
      newLogo = club.logo
      club.logo = ''
    }

    commit('UPDATE_FINANCIAL_CLUB', Object.assign({}, club))
    club.logos = club.logos.filter(c => !c.base64photo)
    club.photos = club.photos.filter(c => !c.base64photo)
    club.isNew = false

    return Vue.axios.put(`/events/clubs`, { club })
    .then(() => {
      newPhotos.reduce(
        (p, v) => p.then((a) => dispatch('loadClubPhoto', { formData: v.data, id: club.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
      newLogos.reduce(
        (p, v) => p.then((a) => dispatch('loadClubSponsorPhoto', { formData: v.data, id: club.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
      speakers.reduce(
        (p, v) => p.then((a) => dispatch('loadClubSpeakerPhoto', { formData: v.photo.data, id: v.id }).then(r => a.concat([r]))),
        Promise.resolve([])
      )
      if (newPhoto) {
        dispatch('loadClubBackgroundPhoto', { formData: newPhoto.data, id: club.id })
      }
      if (newLogo) {
        dispatch('loadClubLogoImage', { formData: newLogo.data, id: club.id })
      }
    })
  },
  loadClubBackgroundPhoto  ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/clubs/${id}/change-club-photo`, formData)
  },
  addMeeting ({ commit }, data) {
    commit('ADD_NEW_MEETING', data)
  },
  updateMeeting ({ commit }, meeting) {
    commit('UPDATE_MEETING', meeting)
  },
  deleteMeeting ({ commit }, id) {
    commit('DELETE_MEETING', id)
  },
  addClubSpeaker ({ commit }, data) {
    commit('ADD_CLUB_SPEAKER', data)
  },
  loadClubSpeakerPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/clubs/speakers/${id}/change-photo`, formData)
  },
  deleteClubSpeakerPhoto ({ commit }, id) {
    return Vue.axios.delete(`/events/clubs/speakers/${id}/change-photo`)
    .then(({ data }) => commit('CHANGE_CLUB_SPEAKER_PHOTO', data))
  },
  deleteClubSpeaker ({ commit }, id) {
    commit('DELETE_CLUB_SPEAKER', id)
  },
  updateClubSpeaker ({ commit }, speaker) {
    commit('UPDATE_CLUB_SPEAKER', speaker)
  },
  addClubAnnouncement ({ commit }, data) {
    commit('CHANGE_CLUB_ANNOUNCEMENT', data)
  },
  deleteClubAnnouncement ({ commit }, id) {
    commit('CHANGE_CLUB_ANNOUNCEMENT', null)
  },
  loadClubPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`/events/clubs/${id}/photos`, formData)
    .then(({ data }) => commit('CHANGE_CLUB_PHOTOS', data))
  },
  deleteClubMember ({ commit, state }, id) {
    return Vue.axios.delete(`/events/clubs/${id}/members`)
    .then(({ data }) => commit('CHANGE_CLUB_MEMBERS', id))
  },
  deleteMeetingParticipant ({ commit, state }, id) {
    return Vue.axios.delete(`/events/clubs/meetings-participants/${id}`)
    .then(({ data }) => commit('DELETE_CLUB_MEETING_PARTICIPANT', id))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/financialClubs.js